import { render, staticRenderFns } from "./ListGiftItem.vue?vue&type=template&id=70947251&scoped=true"
import script from "./ListGiftItem.vue?vue&type=script&lang=js"
export * from "./ListGiftItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70947251",
  null
  
)

export default component.exports